import React from 'react';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { Flex, Span } from '@ubisend/pulse-components';

import { useBot } from '../../../../hooks/index';
import Bubble from './Bubble';

const ImageContainer = styled.div`
  ${tw`bg-cover w-full`};
  ${props => (props.noPointer ? tw`cursor-auto` : tw`cursor-pointer`)};
  background-position: 50% 50%;
  padding-bottom: 56.25%;
`;

const FullSizeImage = styled.img`
  ${tw`w-full`}
`;

const ImageWrapper = ({ full_size = false, url, noPointer, ...props }) => {
  return full_size ? (
    <FullSizeImage src={url} {...props} />
  ) : (
    <ImageContainer
      style={{
        backgroundImage: `url('${url}')`
      }}
      noPointer
      {...props}
    />
  );
};

ImageWrapper.propTypes = {
  full_size: PropTypes.bool,
  url: PropTypes.string,
  noPointer: PropTypes.bool
};

const Image = ({ content, direction, ...props }) => {
  const { setIframeModal, onIframeModalOpen } = useBot();
  const { url, text, full_size = false, image_description } = content;

  const handleImageClick = () => {
    setIframeModal({ type: 'image', value: url });
    onIframeModalOpen('open');
  };

  return (
    <Flex fat="true" right={direction === 'recievedMessage'}>
      <Bubble
        direction={direction}
        style={{
          padding: 0,
          width: '75%'
        }}
        {...props}>
        <ImageWrapper
          full_size={full_size}
          data-testid="clickable-image"
          aria-label={image_description}
          onClick={handleImageClick}
          url={url}
        />
        {text && (
          <Flex padSm>
            <Span fat>{text}</Span>
          </Flex>
        )}
      </Bubble>
    </Flex>
  );
};

Image.propTypes = {
  content: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string,
    full_size: PropTypes.bool,
    image_description: PropTypes.string
  }).isRequired,
  direction: Bubble.propTypes.direction,
  type: PropTypes.string
};

export default Image;
export { ImageContainer, FullSizeImage, ImageWrapper };
